import { render, staticRenderFns } from "./NewQuickResponseModal.vue?vue&type=template&id=f8796792&scoped=true&"
import script from "./new-quick-response-modal.ts?vue&type=script&lang=ts&"
export * from "./new-quick-response-modal.ts?vue&type=script&lang=ts&"
import style0 from "./new-quick-response-modal.scss?vue&type=style&index=0&id=f8796792&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8796792",
  null
  
)

export default component.exports